module.exports = "<div class=\"dialog unsaved-dialog\">\n  <h2 mat-dialog-title>There are unsaved changes</h2>\n  <mat-dialog-content>\n    <div class=\"icon-container\">\n      <mat-icon [@fadeIn]>warning</mat-icon>\n    </div>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button mat-button [mat-dialog-close]=\"{discard: false}\">\n      Cancel\n    </button>\n    <button mat-button [mat-dialog-close]=\"{discard: true}\">\n      Discard\n    </button>\n  </mat-dialog-actions>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/transfers/unsaved-dialog.component.html
// module id = ./src/app/transfers/unsaved-dialog.component.html
// module chunks = main